module.exports = __webpack_public_path__ + "img/IMG_DESTAQUE_430x590px.06923470.jpg";